import React from 'react'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'
import { togglePlayer, setNowPlaying } from '../actions'
import { connect } from 'react-redux'
import { onAirFM, onAirZD } from '~/programs/actions'
import { AudioPlayer } from './AudioPlayer'
// import videojs from 'video.js'

class Player extends React.Component {

  constructor() {
    super()

    this.state = {
      nowPlaying: { title: null, image: null },
      nowPlayingPic: null,
      currentSource: null,
      currentSrc: null
    }
    this.pause = this.pause.bind(this)
    this.loaded = this.loaded.bind(this)
    this.play = this.play.bind(this)
    this.zedPlayer = null
    this.FMGrid = null
    this.playing = false

    this.playerRef = React.createRef();
    this.audioRef = React.createRef();

    let titleTimeout = null
  }
  componentDidMount() {
    const { dispatch } = this.props
    dispatch(onAirFM())
    dispatch(onAirZD())

    if (!this.playerRef.current) {
      const audioElement = this.audioRef.current;

      if (!audioElement) return;

      // const zedPlayer = this.playerRef.current = videojs(audioElement)
      // zedPlayer.on('play', this.play)
      // zedPlayer.on('pause', this.pause)
      // zedPlayer.on('loadstart', this.loaded)
    }


  }

  componentWillReceiveProps(nextProps) {
    const {onAirFM, event} = nextProps
    if(onAirFM.program !== null && onAirFM.program !== this.props.onAirFM.program) {
      this.getTitle()
    }
    if (this.props.event !== event && event.src ) {
      const audioElement = this.audioRef.current;
      if (!audioElement) return;
      const zedPlayer = this.audioRef.current
      if(!zedPlayer.paused){
        zedPlayer.pause()
      }
      zedPlayer.setAttribute('src', event.src.src);
      zedPlayer.load();
      // zedPlayer.src = event.src
      
      // zedPlayer.addEventListener('loadedmetadata' , function() {
      //   this.currentTime(event.position)
      // })

      if(event.position) {
        zedPlayer.addEventListener('loadedmetadata' , function() {
          zedPlayer.fastSeek(event.position);
        })
      }
      //zedPlayer.tech_.el_.children[0].src = ondemandSrc
      zedPlayer.play()
    }
  }

  play() {
    const { nowPlaying, dispatch } = this.props
    if (this.state.currentSource === 'FM' ||this.state.currentSource === 'ZD') {
      ReactGA.event({
        category: 'Media',
        action: 'Stream',
        label: nowPlaying.title
      })
    } else {
      ReactGA.event({
        category: 'Media',
        action: 'Playback',
        label: nowPlaying.title
      })
    }
    dispatch(togglePlayer(true))

    this.playing = true
  }

  pause() {
    console.log('paused, apperently')
    if (this.state.currentSource === 'ZD' || this.state.currentSource === 'FM') {
      this.playerRef.current.src({type: 'audio/mp3', src: this.state.currentSrc})
    }
    console.log(this.state.nowPlaying)
    this.playing = false

  }

  getTitle() {
    let _this = this
    clearTimeout(this.titleTimeout)
    function getTitle(_this) {
      if (_this.state.currentSource === 'FM') {
        _this.getFMTitle()
      }
      else if (_this.state.currentSource === 'ZD') {
        _this.getZDTitle()
      }
      else {
        console.log('do nothing')
      }
      _this.titleTimeout = setTimeout(getTitle, 30000, _this)
    }
    _this.titleTimeout = setTimeout(getTitle, 1000, _this)
  }

  getZDTitle() {
    const { dispatch, onAirZD, nowPlaying } = this.props
    if (nowPlaying.title !== onAirZD.program.name && nowPlaying.image !== onAirZD.program.profileImageSmall ) {
      let url = '/program/' + onAirZD.program.slug
      dispatch(setNowPlaying(onAirZD.program.name, onAirZD.program.profileImageSmall, url))
    }
    this.setState({nowPlaying: { title: onAirZD.program.name, image: onAirZD.program.profileImageSmall }  })
  }

  getFMTitle() {
    const { dispatch, onAirFM, nowPlaying } = this.props
    if (onAirFM.program && nowPlaying.title !== onAirFM.program.name && nowPlaying.image !== onAirFM.program.profileImageSmall ) {
      let url = '/program/' + onAirFM.program.slug
      dispatch(setNowPlaying(onAirFM.program.name, onAirFM.program.profileImageSmall, url))
    }
    this.setState({nowPlaying: { title: onAirFM.program.name, image: onAirFM.program.profileImageSmall }  })
  }

  loaded() {
    console.log()
    let src = this.playerRef.current.src()
    //console.log(src)
    this.playing = false
    clearTimeout(this.titleTimeout)

    if(src === 'https://iheart.4zzz.org.au/4zzz') {
      this.setState({ currentSource: 'FM', currentSrc: src }, this.getTitle )
      console.log('Player src: FM')
    }
    // if(src === 'https://ssl.rockhost.com/proxy/zzzpatr2/stream') {
    //   this.setState({ currentSource: 'FM', currentSrc: src }, this.getTitle )
    //   console.log('Player src: FM')
    // }
    else if ( src === 'https://iheart.4zzz.org.au/zed-digital' ) {
      this.setState({ currentSource: 'ZD', currentSrc: src }, this.getTitle )
      console.log('Player src: ZD')
    }
    else {
      this.setState({ currentSource: null })
      console.log('Player src: POD')
    }
  }

  nowPlaying(x) {
      this.setState({ nowPlaying: x  })
  }

  render() {
    const { visible, nowPlaying } = this.props
    console.log(visible)
    return (
      <div className="content" style={visible ? {display: 'flex'} : {display: 'none'}}>
        <audio ref={this.audioRef} id="zed-live" preload="none"
        data-setup='{ "controlBar": { "fullscreenToggle": false }, "errorDisplay": true  }'>
          <source src="https://iheart.4zzz.org.au/4zzz" type='audio/mp3' />
          {/* <source src="https://ssl.rockhost.com/proxy/zzzpatr2/stream" type='audio/mp3' /> */}
          <p className="vjs-no-js">
            To listen live in the browser please enable JavaScript, and consider upgrading to a web browser that
            <a href="//videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
          </p>
        </audio>
        <AudioPlayer audio={this.audioRef.current} />
      { nowPlaying.url ?
        <div className="now-playing">
          <Link to={nowPlaying.url} >
            <span className="now-playing-title">{nowPlaying.title}</span>
            <img className="now-playing-image" src={nowPlaying.image} />
          </Link>
        </div>
      :
        <div className="now-playing">
          <span className="now-playing-title">{nowPlaying.title}</span>
          <img className="now-playing-image" src={nowPlaying.image} />
        </div>
      }

      </div>
    )
  }

}

export default connect(state => {return { ...state.player, onAirFM: state.onAirFM, onAirZD: state.onAirZD }} ) (Player)
